import * as _ from 'lodash'
import iconUtil from '../utils/icon-util'
import {DEFAULT_LOCALE, ENGLISH_US_LOCALE} from '../enums/locales'

const acceptedFileTypes = ['.notebook']

/**
 * checks if the file is an accepted file type
 * @param file
 * returns {boolean}
 */
let acceptedType = (file) => {
  let fileType = file.name.substring(file.name.lastIndexOf('.'))
  return _.includes(acceptedFileTypes, fileType)
}

/**
 * returns the file name of the file
 * @param file
 * @returns {string}
 */
let fileName = (file) => {
  return file.name.substring(0, file.name.lastIndexOf('.'))
}

/**
 * returns the file path for the correct locale as set on the browser
 * @param setLocale, type
 * @returns {string}
 */
let localeAssetPath = (setLocale, type) => {
  let path = iconUtil.resolve(type)
  let index = path.lastIndexOf('.')
  if (setLocale === DEFAULT_LOCALE || setLocale === ENGLISH_US_LOCALE || !fileExists(`${path.slice(0, index)}.${setLocale}${path.slice(index)}`)) {
    return path
  } else {
    return `${path.slice(0, index)}.${setLocale}${path.slice(index)}`
  }
}

let fileExists = (path) => {
  let http = new XMLHttpRequest()
  http.open('HEAD', path, false)
  http.send()
  return http.status !== 404
}

export default {
  acceptedType,
  fileName,
  localeAssetPath
}
